import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './slices/authSlice';
import modalReducer from './slices/modalSlice';
import { apiSlice } from './slices/apiSlice';
import webcastLoginReducer from './slices/webCastLoginSlice';
import { webCastApiSlice } from './slices/webCastApiSlice';
import { mediaApiSlice } from './slices/mediaApi';
import { profileApiSlice } from './slices/profileApi';
import ecclesialDocSlice from './slices/ecclesialDocumentSlice';
import { resourcesApiSlice } from './slices/resourcesApiSlice';
import { contactUsApiSlice } from './slices/contactUsSlice';
import { webCastUsageApiSlice } from './slices/webCastUsageApi';
import syllabusSlice from './slices/syllabusSlice';
import { syllabusApiSlice } from './slices/syllabusApiSlice';
import { eventApiSlice } from './slices/eventsApi';
import { bibleSeminarsApiSlice } from './slices/bibleSeminarsApiSlice';
import tagReducer from './slices/tagSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    modal: modalReducer,
    ecclesialDocs: ecclesialDocSlice,
    syllabusSlice: syllabusSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
    webcastLogin: webcastLoginReducer,
    [webCastApiSlice.reducerPath]: webCastApiSlice.reducer,
    [mediaApiSlice.reducerPath]: mediaApiSlice.reducer,
    [profileApiSlice.reducerPath]: profileApiSlice.reducer,
    [webCastUsageApiSlice.reducerPath]: webCastUsageApiSlice.reducer,
    [resourcesApiSlice.reducerPath]: resourcesApiSlice.reducer,
    [syllabusApiSlice.reducerPath]: syllabusApiSlice.reducer,
    [contactUsApiSlice.reducerPath]: contactUsApiSlice.reducer,
    [eventApiSlice.reducerPath]: eventApiSlice.reducer,
    [bibleSeminarsApiSlice.reducerPath]: bibleSeminarsApiSlice.reducer,
    tags: tagReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiSlice.middleware,
      webCastApiSlice.middleware,
      mediaApiSlice.middleware,
      profileApiSlice.middleware,
      resourcesApiSlice.middleware,
      contactUsApiSlice.middleware,
      syllabusApiSlice.middleware,
      webCastUsageApiSlice.middleware,
      eventApiSlice.middleware,
      bibleSeminarsApiSlice.middleware
    )
});

setupListeners(store.dispatch);
